/* eslint-disable react-hooks/exhaustive-deps */
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Mixpanel } from "../../../config/Mixpanel";
import constants from "../utilities/constants";
import { useDispatch } from "react-redux";
import useLearnTubeXTimer from "../hooks/useLearnTubeXTimer";
import { fetchRazorPayStatusForLearntubeX } from "../../../redux/personaliseLessons/razorPayLearntubeXSlice";
import axios from "axios";
import { RAZORPAY_KEY } from "../../../config/api_config";
import useRazorpay from "react-razorpay";
import { ClipLoader } from "react-spinners";
import { setShowBanner } from "../../../redux/personaliseLessons/bottomIllustration";
import { toast } from "react-toastify";
import { axiosNoAuth } from "../../../redux/personaliseLessons/axiosInstance";

const LearnTubeXIllustartion = ({
  sentinelRef,
  setIsAtEnd,
  authentication,
}) => {
  const { uid, email, userName, userPhone } = authentication;

  const [loader, setLoader] = useState(false);

  const remaningTimer = useLearnTubeXTimer();
  const Razorpay = useRazorpay();
  const dispatch = useDispatch();

  const formatTime = (time) => {
    const seconds = Math.floor((time / 1000) % 60);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const hours = Math.floor(time / (1000 * 60 * 60));

    return `${hours.toString().padStart(2, "0")}H :
                ${minutes.toString().padStart(2, "0")}M :
                ${seconds.toString().padStart(2, "0")}S`;
  };

  useEffect(() => {
    const sentinel = sentinelRef?.current;
    const observer = new IntersectionObserver((entries) => {
      // If the sentinel comes into view, setIsAtEnd to true
      if (entries[0].isIntersecting) {
        setIsAtEnd(true);
      } else {
        setIsAtEnd(false);
      }
    });

    if (sentinelRef?.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinel) {
        observer.unobserve(sentinel);
      }
    };
  }, [sentinelRef]);

  const razorpayHandler = async (callback) => {
    try {
      const response = await axiosNoAuth.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/create_subscription_test",
        {
          uid: uid,
          plan_name: "LearnTubeX Unlimited (base personalised ltx)",
          product_name: "LearnTubeX Unlimited (base personalised ltx)",
        },
      );
      const options = {
        key: RAZORPAY_KEY,
        currency: "INR",
        name: userName,
        description: "LearnTubeX Unlimited (base personalised ltx)",
        image: "",
        subscription_id: response.data?.subscription_id,
        modal: {
          ondismiss: function () {
            callback();
          },
        },
        handler: (res) => {
          getOrderStatusSuccess(res);
          callback();
        },
        prefill: {
          name: userName,
          email: email,
          contact: userPhone,
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#26CBA1",
        },
      };
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        callback();
        getOrderStatusFailed(response);
      });
      rzp1.open();
    } catch (error) {
      toast.error("Something Went Wrong! Try Again");
    } finally {
      callback();
    }
  };

  const getOrderStatusSuccess = async (response) => {
    await dispatch(
      fetchRazorPayStatusForLearntubeX({
        uuid: uid,
        payment_id: response?.razorpay_payment_id,
        subscription_id: response?.razorpay_subscription_id,
        isError: false,
        razorpay_signature: response?.razorpay_signature,
        errorObj: {},
      }),
    );

    dispatch(setShowBanner(false));
  };

  const getOrderStatusFailed = async (response) => {
    dispatch(
      fetchRazorPayStatusForLearntubeX({
        uuid: uid,
        payment_id: response?.error?.metadata?.payment_id,
        subscription_id: response?.error?.metadata?.order_id,
        isError: true,
        razorpay_signature: "",
        errorObj: { ...response?.error },
      }),
    );
  };

  return (
    <div className="flex flex-col items-center rounded-xl border-2 border-[#7FC241] bg-[#2D4F71] p-4 lg:items-start lg:p-6">
      <div ref={sentinelRef} style={{ height: "1px" }}></div>
      <div className="lg:flex">
        <div className="mx-auto h-full w-[195px] flex-shrink-0 lg:w-[200px]">
          <img
            src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/successful-businessman-archive-career-growth_1.png?updatedAt=1686901583248"
            loading="lazy"
            alt=""
            className="h-full w-full object-center"
          />
        </div>
        <div className="w-full">
          <h2 className="text-center text-[32px] leading-8 lg:text-left">
            {userName}, Unlock{" "}
            <span className="font-bold text-[#00C1FF]">Unlimited Learning</span>{" "}
            With LearnTubeX
          </h2>
          <p className="mx-auto mt-2 mb-2 w-[89%] text-center text-sm leading-[17px] lg:mx-0 lg:w-[95%] lg:text-left lg:text-base">
            Become the top 1% with access to unlimited personalised courses,
            unlimited doubt solving, voice & multi-language support, priority
            call support & a free CV + Linkedin review.
          </p>
        </div>
      </div>
      <div ref={sentinelRef} style={{ height: "1px" }}></div>
      <div className="w-full lg:flex lg:items-center lg:justify-between">
        <div className="">
          {remaningTimer > 0 ? (
            <div className="mx-auto">
              <p className="mt-3 text-center text-sm font-semibold lg:text-left lg:text-base">
                Early-Bird Discount Till:
              </p>
              <div className="mx-auto mt-1 max-w-[150px] rounded-lg border-2 border-[#E06064] px-1.5 py-1 text-center font-extrabold text-[#E06064]">
                {formatTime(remaningTimer)}
              </div>
            </div>
          ) : null}
          <p className="mt-2 mb-5 text-center text-sm lg:mb-0 lg:text-base">
            Only <span className="font-bold opacity-80">₹399/Month</span>{" "}
            <span className="text-[#E06064]">₹</span>
            <span className="text-[#E06064] line-through">3999</span>
          </p>
        </div>
        <div
          className="mx-auto flex h-[55px] cursor-pointer items-center justify-center rounded-xl bg-[#7FC241] px-2 py-3 text-center font-semibold text-black lg:mx-0 lg:w-[330px]"
          onClick={() => {
            Mixpanel.track(constants.Mixpanel.NORMAL_PAYMENT_BUTTON);
            setLoader(true);
            razorpayHandler(() => setLoader(false));
          }}
        >
          {loader ? (
            <ClipLoader size={20} />
          ) : (
            <p className="font-semibold ">Upgrade to LearnTubeX</p>
          )}
          {!loader && (
            <FontAwesomeIcon
              icon={faArrowRight}
              className="arrow-move ml-4 text-xl font-bold"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LearnTubeXIllustartion;
